<template>
  <form class="form-single" v-on:submit.prevent="verifyAndSubmit">
    <div class="row">
      <div class="col-1">
        <h3 class="title">Acesso ao CMS - Alterar Senha</h3>
      </div>
    </div>
    <div class="row">
      <div style="padding-right: 10px;" class="col-1-2">
        <div class="row">
          <div class="col-1">
            <div class="form-group">
              <label for>Senha Atual</label>
              <input autocomplete="off" type="password" v-model="senhaAtual" class="form-control" />
              <div class="message">{{ validation.firstError('senhaAtual') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="border-left: 1px solid #ccc; padding-left: 10px;" class="col-1-2">
        <div class="row">
          <div class="col-1">
            <div class="form-group">
              <label for>Senha Nova</label>
              <input autocomplete="off" type="password" v-model="senhaNova" class="form-control" />
              <div class="message">{{ validation.firstError('senhaNova') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
            <div class="form-group">
              <label for>Repetir Senha Nova</label>
              <input
                autocomplete="off"
                type="password"
                v-model="senhaNovaRepeat"
                class="form-control"
              />
              <div class="message">{{ validation.firstError('senhaNovaRepeat') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <button class="button button-success">Alterar</button>
    </div>
  </form>
</template>
<script>
import { post } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;
const url = "/configuracao/trocar-senha";

export default {
  name: "senha",
  props: ["onSubmit"],
  data() {
    return {
      senhaAtual: "",
      senhaNova: "",
      senhaNovaRepeat: ""
    };
  },
  validators: {
    senhaAtual: function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    },
    senhaNova: function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    },
    "senhaNovaRepeat, senhaNova": function(senhaNovaRepeat, senhaNova) {
      return Validator.value(senhaNovaRepeat)
        .required("Campo obrigatório.")
        .match(senhaNova, "As senhas não conferem.");
    }
  },
  methods: {
    verifyAndSubmit() {
      const { senhaAtual, senhaNova } = this;
      this.$validate().then(success => {
        if (success) {
          this.onSubmit({
            senhaAtual,
            senhaNova
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Config/Avancado/Senha.vue